export default __webpack_public_path__ + "static/logo_koona_white-e59a88e3153e08073a61bc7d046a9c64.png";